module.exports = __webpack_public_path__ + "img/lock-off.6356660c.svg";